





































import { Component, Vue, Watch } from 'vue-property-decorator';
import Logo from '/src/components/common/logo.vue'

@Component({
  name:'appMenu',
  components: {
    Logo
  }
})
export default class appMenu extends Vue {
  defaultActive = '/main/index';

    /*
   *@description:'权限树 前端当做菜单使用'
   */
  get menuTreeList() {
    return this.$store.state.permissionTreeList;
  }

  // 定义icon 图标映射关系
  iconFontTree = {
    'icon_home': 'icon-homeoutlined',
    'icon_homePage': 'icon-homeoutlined',
    'icon_nav': 'icon-flagoutlined',
    'icon_goods': 'icon-shoppingcartoutlined',
    'icon_order': 'icon-filetextoutlined',
    'icon_freight': 'icon-caroutlined', // 运费
    'icon_content': 'icon-diffoutlined',
    'icon_money': 'icon-accountbookoutlined',
    'icon_user': 'icon-teamoutlined1',
    'icon_set': 'icon-settingoutlined1',
    'icon_setUpThe': 'icon-settingoutlined1',
  }
  // 获取icon 图标类名
  getIconClassName(iconStr) {
    const num = iconStr.lastIndexOf('.');
    return this.iconFontTree[num > 0 ? iconStr.substring(iconStr.lastIndexOf('/') + 1, num) : iconStr.substring(iconStr.lastIndexOf('/') + 1)];
  }

  @Watch('$route', { deep: true, immediate: true })
  handler(newVal) {
    if (newVal && newVal.path) {
      if (newVal.path === '/main/index') {
        this.defaultActive = '/main/index';
      } else {
        // 非菜单页面 根据路由的 parentPath 来设置 菜单激活项
        if (newVal?.meta?.parentPath) {
          this.defaultActive = newVal?.meta?.parentPath;
          return;
        }
        this.defaultActive = newVal.path;
      }
    }
  }


  getImgUrl(img) {
    return require('@/image/home_icon/' + img + '.png');
  }

}
